import axios, { AxiosError } from "axios";
import { useState } from "react";
import { RxCross2 } from "react-icons/rx";
import { toast } from "react-toastify";
import api from "../api";

function AddPrompt({ handlePromptClick, closePrompt, setRefresh }: any) {
  const [name, setName] = useState("");
  const [description, setDescription] = useState<string>("");

  const handleNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setName(e.target.value);
  };

  const handleUploadSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (/[ !@#$%^&*()+\-=\[\]{};':"\\|,.<>\/?]/.test(name)) {
      toast.error(
        "Prompt name must not include spaces or special characters!",
        {
          position: "top-center",
          autoClose: 2000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          theme: "dark",
        }
      );
      return;
    }

    try {
      const formData = new FormData();
      formData.append("prompt_name", name);
      formData.append("prompt_text", description);

      await api.post(`${process.env.REACT_APP_USER_PROMPT_CREATE}`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      setRefresh((prevRefresh: any) => prevRefresh + 1);
      closePrompt();

      toast.success("Business Rule has been created successfully!", {
        position: "top-center",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        theme: "dark",
      });
    } catch (error) {
      if (axios.isAxiosError(error)) {
        const axiosError = error as AxiosError;
        const errorMessage = axiosError.message;

        toast.error(
          `An error occurred while creating the Business Rule: ${errorMessage}`,
          {
            position: "top-center",
            autoClose: 2000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: false,
            theme: "dark",
          }
        );
      } else {
        toast.error(
          "An unexpected error occurred while creating the Business Rule",
          {
            position: "top-center",
            autoClose: 2000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: false,
            theme: "dark",
          }
        );
      }
      console.error("Error creating the Business Rule:", error);
    }
  };

  return (
    <div
      className="fixed inset-0 flex items-center justify-center z-50 backdrop-blur-md"
      onClick={handlePromptClick}
      role="button"
    >
      <div className="bg-white p-4 rounded shadow-2xl relative">
        <button
          onClick={closePrompt}
          className="text-[25px] bg-[#4D30B5] hover:bg-[#1b1436] duration-300 rounded-lg p-1 text-white absolute top-2 right-2"
        >
          <RxCross2 size={25} className="-mt-[1px]" />
        </button>

        <p className="text-[25px] text-center content-center">
          Upload a business Rule
        </p>

        <form
          onSubmit={handleUploadSubmit}
          className=" md:w-[750px] w-[350px] "
        >
          <div className="mt-4">
            <label htmlFor="name" className="block">
              Name:
            </label>
            <input
              type="text"
              value={name}
              onChange={handleNameChange}
              className="border rounded p-2 w-full outline-none"
              required
            />
          </div>
          <div className="mt-4">
            <label htmlFor="description" className="block">
              Business Rule:
            </label>
            <pre>
              <code>
                <textarea
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  className="border rounded p-2 w-full h-[200px] outline-none"
                  required
                />
              </code>
            </pre>
          </div>
          <div className="mt-4 flex justify-center">
            <button
              type="submit"
              className="bg-[#4D30B5] hover:bg-[#1b1436] text-white px-5 py-3 rounded duration-300"
            >
              Create Business Rule
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default AddPrompt;
